<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="1100px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <el-form-item label="使用单位：">
          <el-select
            size="mini"
            v-model="form.propertyUnitId"
            filterable
            placeholder="请选择所属单位"
            clearable
            reserve-keyword
            :remote="true"
            @change="handleSearchListData"
            :remote-method="searchUnitList"
            @visible-change="searchUnitList('')"
          >
            <el-option
              v-for="item in unitList"
              :key="item.id"
              :label="item.unitName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目：">
          <el-select
            size="mini"
            v-model="form.projectId"
            filterable
            placeholder="请选择所属项目"
            clearable
            reserve-keyword
            :remote="true"
            @change="handleSearchListData"
            :remote-method="searchProjectList"
            @visible-change="searchProjectList('')"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.projectName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门：">
          <el-cascader
            placeholder="请选择所属部门"
            :options="departmentTree"
            :props="propsTree"
            filterable
            size="mini"
            @change="handleDepartment"
            ref="cascader"
            collapse-tags
            v-model="departmentIdList"
          ></el-cascader>
        </el-form-item>
        <!-- <el-form-item label="使用编号：">
          <el-input
            @change="handleSearchListData"
            size="mini"
            v-model.trim="form.useCertificateNumber"
            placeholder="请输入使用编号"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="省市区：" class="input-with-col2 addressBoxItem">
          <AddreassSelect
            :isSearch="true"
            :warning="addressWarn"
            :showDetailAddress="showDetailAddress"
            :addressName="addressName"
            @change="setPojectAddress"
          ></AddreassSelect>
        </el-form-item>

        <!-- <el-form-item label="电梯位置：">
          <el-input
            @change="handleSearchListData"
            size="mini"
            v-model.trim="form.liftLocation"
            placeholder="请输入电梯位置"
            clearable
          ></el-input>
        </el-form-item> -->

        <!-- <el-form-item label="维保员：">
          <el-select
            size="mini"
            v-model="form.maintainPersonIdList"
            filterable
            placeholder="请选择维保员"
            clearable
            reserve-keyword
            :remote="true"
            collapse-tags
            multiple
            @change="handleSearchListData"
            :remote-method="searchUserList"
            @visible-change="searchUserList('')"
          >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.nickname"
              :value="item.userId"
            ></el-option>
          </el-select> -->
        <!-- </el-form-item> -->
      </el-form>
      <el-table :data="tableData" style="width: 100%" max-height="400">
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="contractNumber"
          label="合同编号"
          width="120"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="right"
          header-align="right"
          prop="contractAmount"
          label="合同金额"
          width="150"
          sortable="custom"
        >
          <template slot-scope="scope">{{
            scope.row.contractAmount | separator
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="endTime"
          label="到期时间"
          width="100"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="projectName"
          label="项目名称"
          width="150"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="projectAddress"
          label="项目地址"
          width="150"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="propertyUnitName"
          label="使用单位名称"
          width="150"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="liftNum"
          label="电梯台数"
          width="90"
        ></el-table-column>
        <el-table-column prop=" "> </el-table-column>
      </el-table>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getFinancialOverdueList } from "@/api/UserConsole";
import { getUnitSimpleList } from "@/api/ProjectManagement";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import { getUserSimpleList } from "@/api/MaintenancePlan";
import { getDepartmentTree } from "@/api/ElevatorManagement";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";

export default {
  data() {
    return {
      form: {
        propertyUnitId: "",
        projectId: "",
        useCertificateNumber: "",
        liftLocation: "",
        maintainPersonIdList: [],
      },
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 25,
      unitList: [],
      projectList: [],
      addressWarn: false,
      showDetailAddress: true,
      addressName: "省市区",
      departmentTree: [],
      propsTree: {
        multiple: true,
        value: "id",
        label: "departmentName",
        children: "childrenList",
        // checkStrictly: true
      },
      departmentIdList: [],
      userList: [],
      title: "合同即将到期",
    };
  },
  components: {
    AddreassSelect,
  },
  props: {
    getDetailParams: {
      type: Object,
      required: true,
    },
  },
  created() {
    console.log(this.getDetailParams);
    if (this.getDetailParams.statisticType === 1) {
      this.title = "合同即将到期";
    } else {
      this.title = "合同已到期";
    }
    this.getFinancialOverdueList();
    this.getDepartmentTree();
  },
  methods: {
    async getDepartmentTree() {
      const res = await getDepartmentTree({ pageIndex: 1, pageSize: 1000 });
      if (res.code === 200) {
        this.departmentTree = res.data;
      }
    },
    async searchUserList(keyword) {
      const res = await getUserSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.userList = res.data;
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$emit("cancel");
    },
    async getFinancialOverdueList() {
      const params = { ...this.getDetailParams, ...this.form };
      params.pageSize = this.pageSize;
      params.pageIndex = this.pageIndex;
      const res = await getFinancialOverdueList(params);
      if (res.code === 200) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getFinancialOverdueList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getFinancialOverdueList();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getFinancialOverdueList();
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
      this.handleSearchListData();
    },
    handleDepartment(val) {
      this.form.departmentIdList = [];
      if (val && val.length) {
        const nodes = this.$refs.cascader.getCheckedNodes();
        nodes.forEach((item) => {
          this.form.departmentIdList.push(item.data.id);
        });
      }
      this.handleSearchListData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/UserConsole/components/Contract.vue